/**
 * Serviço para buscar endereço por CEP usando ViaCEP API
 * API gratuita e sem necessidade de autenticação
 */

/**
 * Formata CEP removendo caracteres não numéricos
 */
export function formatCepForApi(cep) {
  if (!cep) return '';
  return cep.replace(/\D/g, '');
}

/**
 * Valida se o CEP tem formato válido (8 dígitos)
 */
export function isValidCep(cep) {
  const cleanCep = formatCepForApi(cep);
  return cleanCep.length === 8;
}

/**
 * Busca endereço completo por CEP
 */
export async function fetchAddressByCep(cep) {
  const cleanCep = formatCepForApi(cep);
  
  if (!isValidCep(cleanCep)) {
    throw new Error('CEP inválido. Deve conter 8 dígitos.');
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar CEP. Tente novamente.');
    }

    const data = await response.json();

    if (data.erro) {
      throw new Error('CEP não encontrado.');
    }

    return {
      cep: data.cep,
      address: data.logradouro || '',
      complement: data.complemento || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
    };
  } catch (error) {
    if (error.message.includes('fetch')) {
      throw new Error('Erro de conexão. Verifique sua internet.');
    }
    throw error;
  }
}

/**
 * Formata CEP para exibição (00000-000)
 */
export function formatCepDisplay(cep) {
  const cleanCep = formatCepForApi(cep);
  if (cleanCep.length !== 8) return cleanCep;
  return `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`;
}
